import {Component, Input, OnChanges} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {DeviceParamGatewayV3} from "../../../../../../shared/classes/device/type-gateway-v3/device-param-gateway-v3";

@Component({
    selector: 'app-param-main',
    templateUrl: './param-main.component.html',
    styleUrls: ['./param-main.component.css']
})
export class ParamMainComponent implements OnChanges {

    mainForm: FormGroup;
    @Input('deviceParamGatewayV3') deviceParamGatewayV3: DeviceParamGatewayV3;
    @Input('editable') editable: boolean = true;

    constructor() {
    }

    ngOnChanges() {
        if (!this.deviceParamGatewayV3) return;
        if (this.mainForm) return;
        this.mainForm = new FormGroup({
            dynDns: new FormControl(this.deviceParamGatewayV3.dynDns),
            networks_idx: new FormControl(this.deviceParamGatewayV3.networks_idx)
        })
    }

    setDeviceWithForm() {
        this.deviceParamGatewayV3.dynDns = this.mainForm.value.dynDns;
        this.deviceParamGatewayV3.networks_idx = this.mainForm.value.networks_idx;
    }

}
